module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-41.a557d49a.png";